import { useClassNames } from '@magnetic/hooks';
import { consoleWarn } from '@magnetic/lib';
import React, { forwardRef } from 'react';
import { IcStatusAlert } from './ic-status-alert.js';
import { IcStatusAllow } from './ic-status-allow.js';
import { IcStatusConnected } from './ic-status-connected.js';
import { IcStatusCritical } from './ic-status-critical.js';
import { IcStatusDeny } from './ic-status-deny.js';
import { IcStatusDisabled } from './ic-status-disabled.js';
import { IcStatusDisconnected } from './ic-status-disconnected.js';
import { IcStatusDormant } from './ic-status-dormant.js';
import { IcStatusGood } from './ic-status-good.js';
import { IcStatusInfo } from './ic-status-info.js';
import { IcStatusNeutral } from './ic-status-neutral.js';
import { IcStatusWarning } from './ic-status-warning.js';

const statusIconMap = {
  alert: IcStatusAlert,
  disabled: IcStatusDisabled,
  // General Status
  good: IcStatusGood,
  warning: IcStatusWarning,
  critical: IcStatusCritical,
  neutral: IcStatusNeutral,
  info: IcStatusInfo,
  // Policy Status
  allow: IcStatusAllow,
  deny: IcStatusDeny,
  // Device Icons
  connected: IcStatusConnected,
  disconnected: IcStatusDisconnected,
  dormant: IcStatusDormant
};
const Status = forwardRef(
  ({ className, hasBackground = false, status, ...svgProps }, ref) => {
    consoleWarn({
      prop: status,
      propValues: ["connected", "disconnected", "dormant", "disabled"],
      message: "The connected, disconnected, dormant and disabled statuses for the `StatusIcon` are deprecated, please consider using `DeviceStatus` instead."
    });
    const classNames = useClassNames(className, {
      "mds-rebuild-status-icon": true,
      "mds-rebuild-status-icon-with-background": hasBackground
    });
    const StatusIcon = statusIconMap[status];
    return /* @__PURE__ */ React.createElement(
      StatusIcon,
      {
        "aria-label": status,
        ...svgProps,
        className: classNames,
        ref
      }
    );
  }
);

export { Status };
//# sourceMappingURL=index.js.map
